// SPDX-License-Identifier: LGPL-3.0-or-later
/** Whether to perform access checks */
export let checkAccess = true;
/**
 * @internal @hidden
 */
export function _setAccessChecks(value) {
    checkAccess = value;
}
